import { BlipNamespace } from "@/common/BlipNamespace";

export class PathResolver {
  static resolveContentDetailPath(namespace, unitId, contentId) {
    switch (namespace) {
      case BlipNamespace.COLLECTION:
      case BlipNamespace.COLLECTION_COMMENT:
        return `/collection/collectionDetail?collectionId=${contentId}&unitId=${unitId}`;
      case BlipNamespace.TOPIC:
      case BlipNamespace.TOPIC_COMMENT:
        return `/topic/detail/${contentId}`;
      case BlipNamespace.RADAR:
      case BlipNamespace.RADAR_COMMENT:
        return `/radars/radarContentDetail?unitId=${unitId}&contentId=${contentId}`;
      case BlipNamespace.FAN_LOG:
        return `/fanLog/fanLogDetail?fanLogId=${contentId}`;
      case BlipNamespace.VIEWER_COMMENT:
        return `/viewer?unitId=${unitId}&contentId=${contentId}`;
      case BlipNamespace.KPOP_NOW_COMMENT:
        return `/viewer/rank?unitId=${unitId}&contentId=${contentId}`;
    }
  }
}
